import ExcelJS, { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { getLanguage } from "helpers/translations";
import { excelSheetLocation } from "./sheet/excel-sheet-location";
import { excelSheetHazard } from "./sheet/excel-sheet-hazard";
import { excelSheetClimate } from "./sheet/excel-sheet-climate";
import { excelSheetFathom } from "./sheet/excel-sheet-fathom";
import { excelSheetEvent } from "./sheet/excel-sheet-event";
import { handleFilterLocations } from "helpers/helpers";
import { handleGetMultipleResultGroupData } from "helpers/groupResultData";
import { excelItem } from "./location/location-item-row";

export const downloadExcel = async (context: any, t: any) => {
const multipleLocationsSearch = context.multipleLocationsSearch;
const locationsFilterInfo = context.locationsFilterInfo;
  const language = getLanguage();
  const templateEn = "/template/download/download_en.xlsx";
  const templateCn = "/template/download/download_cn.xlsx";
  const templateUrl = language === "en" ? templateEn : templateCn;
  const templateUrlWithRandom = `${templateUrl}?_=${Date.now()}`;
  const response = await fetch(templateUrlWithRandom);
  const templateArrayBuffer = await response.arrayBuffer();

  const workbook: Workbook = new ExcelJS.Workbook();

  await workbook.xlsx.load(templateArrayBuffer);

  const locationsTable = handleFilterLocations({
    data: context.currentMultipleLocations?.items || [],
    unit:
      context.currentMultipleLocations?.aggregationUnit ?? "numberOfLocations",
    multipleLocationsSearch: multipleLocationsSearch,
    locationsFilterInfo: locationsFilterInfo,
    filterChecked: true
  });

  const sortedLocationsTable = excelItem(locationsTable);

  const hazardResult: any[] =
    context.hazardMultipleAnalysisStore && context.hazardMultipleAnalysedLegends
      ? handleGetMultipleResultGroupData({
          storeData: context.hazardMultipleAnalysisStore,
          locationsTableData: sortedLocationsTable,
          legendData: context.hazardMultipleAnalysedLegends,
          needNoData: false,
          needChartData: false
        }).pdfResult
      : [];

  const eventResult: any[] =
    context.eventAnalysisStore && context.eventAnalysisLegend
      ? handleGetMultipleResultGroupData({
          storeData: context.eventAnalysisStore,
          locationsTableData: sortedLocationsTable,
          legendData: context.eventAnalysisLegend,
          needNoData: false,
          needChartData: false
        }).pdfResult
      : [];

  const eventLegend = context.eventAnalysisLegend;

  excelSheetLocation(workbook, context.currentMultipleLocations);
  excelSheetHazard(t, workbook, 2, sortedLocationsTable, hazardResult);
  excelSheetEvent(
    t,
    workbook,
    8,
    sortedLocationsTable,
    eventResult,
    eventLegend
  );
  excelSheetFathom(t, workbook, 3, sortedLocationsTable, hazardResult);
  excelSheetClimate(context, t, workbook, 4, "SSP1-2.6", sortedLocationsTable);
  excelSheetClimate(context, t, workbook, 5, "SSP2-4.5", sortedLocationsTable);
  excelSheetClimate(context, t, workbook, 9, "SSP3-7.0", sortedLocationsTable);
  excelSheetClimate(context, t, workbook, 6, "SSP5-8.5", sortedLocationsTable);

  const buf = await workbook.xlsx.writeBuffer();

  saveAs(
    new Blob([buf], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }),
    `${context.currentMultipleLocations?.name}.xlsx`
  );
};


